import { Flex, Text } from '@chakra-ui/react';
import { faFileMagnifyingGlass } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ButtonText, Link } from '@morressier/alembic';
import React from 'react';

import { getClientConfig } from '../../utils/config';

interface Props {}

const IntegrityWorkspaces: React.FC<Props> = props => {
  const handleViewIntegrityWorkspaces = () => {
    const { integrity_base_url } = getClientConfig();
    window.open(`${integrity_base_url}/integrity/workspace`, '_blank');
  };

  return (
    <Flex
      width="100%"
      padding="16px"
      backgroundColor="surfaceTertiaryFill"
      justifyContent="center"
      gap="8px"
      margin="32px 0"
      height="56px"
      alignItems="center"
    >
      <FontAwesomeIcon icon={faFileMagnifyingGlass} />
      <Text textStyle="headingLine">
        Looking for Your Integrity Workspaces?
      </Text>
      <ButtonText onClick={handleViewIntegrityWorkspaces}>
        View Your Workspaces
      </ButtonText>
    </Flex>
  );
};

export default IntegrityWorkspaces;
